import $ from 'jquery';
import { isTouch } from '../../utils/inspection';
import { frame } from '../../utils/drawing';
import { directiveSettings } from '../../utils/parse';
import { onScroll } from '../../utils/window';

const $window = $(window);

export default function revealDirective(context=document.body) {
    const $context = $(context);
    const $reveal = $context.find('[sw-reveal]');

    $(function(){
        if (!isTouch()) {

            function checkForReveal(element, reset=false) {
                const $this = $(element);
                const isScrolled = $window.scrollTop() + $window.outerHeight() > $this.offset().top;
                if (isScrolled && !$this.hasClass('is-revealed')) {
                    setTimeout(function(){
                        $this.addClass('is-revealed');
                    }, 10);
                } else if(reset && !isScrolled && $this.hasClass('is-revealed')) {
                    $this.removeClass('is-revealed')
                }
            }
    
            $reveal.each(function() {
                const $element = $(this);
                const json = $element.attr('sw-reveal');
                const settings = directiveSettings(json, {
                    force: false,
                    reset: true,
                }, 'force');
    
                if (!settings.force) {
                    $element.css('transition', 'none');
                }
                
                checkForReveal($element, settings.reset)
    
                if (!settings.force) {
                    frame(() => $element.css('transition', ''));
                }

                onScroll(() => checkForReveal($element, settings.reset));
            });
    
        } else {
    
            $reveal.css('transition', 'none');
            $reveal.addClass('is-revealed');
        }
    });
}



// WEBPACK FOOTER //
// ./source/scripts/directives/scroll/reveal.js